const AboutUs = () => {
  return (
    <>
      <div>This is the about us page</div>
    </>
  );
};

export default AboutUs;
